<template lang="html">
    <div id="cost-menu">
        <md-tabs :md-active-tab="activeTab">
            <md-tab id="tab-discounts"        v-bind:to="{ name: 'Discounts'}"          md-label="Скидки"></md-tab>

            <md-tab id="tab-luwprices"        v-bind:to="{ name: 'LuwPrices'}"  md-label="ПРР"></md-tab>
            <md-tab id="tab-doom-prices"      v-bind:to="{ name: 'DoomPrices'}" md-label="Обрешётка"></md-tab>
            <md-tab id="tab-forwardingprices" v-bind:to="{ name: 'ForwardingPrices'}"   md-label="Экспедирование"></md-tab>
            <md-tab id="tab-services"         v-bind:to="{ name: 'AdditionalServices'}" md-label="Дополнительные услуги"></md-tab>
            
            <md-tab id="tab-other"            v-bind:to="{ name: 'OtherSettings'}"      md-label="Прочие параметры"></md-tab>
            <md-tab id="tab-paymentmethods"   v-bind:to="{ name: 'PaymentMethods'}"     md-label="Способы оплаты"></md-tab>
            <md-tab id="tab-zones"            v-bind:to="{ name: 'Zones'}"  md-label="Направления"></md-tab>
            <md-tab id="tab-cities"           v-bind:to="{ name: 'Cities'}" md-label="Населённые пункты"></md-tab>
        </md-tabs>
    </div>
</template>
<script>
    export default {
        name: 'user-menu',
        data() {
            return {
                title: '',
                activeTab: ''
            }
        },
        watch: {
            '$route'() {
                this.activeTab = 'tab-' + this.$route.meta.tab;
            }
        },
        computed: {},
        created() {
            this.activeTab = 'tab-' + this.$route.meta.tab;
        },
        methods: {}
    }
</script>



// WEBPACK FOOTER //
// menu.vue?0176f1d5